const theme = {
  images: {
    shareLinks: '{{configs.publicUrl}}/assets/illustrations/share-links.svg',
    welcomeModalImage1: '{{configs.publicUrl}}/assets/images/welcome-modal-1.webp',
    welcomeModalImage2: '{{configs.publicUrl}}/assets/images/welcome-modal-2.webp',
    welcomeModalImage3: '{{configs.publicUrl}}/assets/images/welcome-modal-3.webp',
    expiredGift: '{{configs.publicUrl}}/merchants/{{configs.merchantName}}/images/expired-gift.svg',
    noImage: '{{configs.publicUrl}}/assets/images/no-image.svg',
    sendWithoutContactCard:
      '{{configs.publicUrl}}/merchants/{{configs.merchantName}}/images/send-without-contacts-card.svg',
    previewFrame: '{{configs.publicUrl}}/assets/images/via-email-preview.svg',
    notFound: '{{configs.publicUrl}}/merchants/{{configs.merchantName}}/images/404.png',
    error: '{{configs.publicUrl}}/merchants/{{configs.merchantName}}/images/503.png',
    onboardingInfoCard1:
      '{{configs.publicUrl}}/merchants/{{configs.merchantName}}/images/onboarding-info-card-1.svg',
    giftBasketMoreInformation11:
      '{{configs.publicUrl}}/merchants/{{configs.merchantName}}/images/gift-basket.png',
    giftBasketMoreInformation12:
      '{{configs.publicUrl}}/merchants/{{configs.merchantName}}/images/Cost-estimate.png',
    addContactMoreInformation11:
      '{{configs.publicUrl}}/merchants/{{configs.merchantName}}/images/add-new-contacts.png',
    addContactMoreInformation12:
      '{{configs.publicUrl}}/merchants/{{configs.merchantName}}/images/add-new-contacts-2.png',
    scratch: '{{configs.publicUrl}}/merchants/{{configs.merchantName}}/images/scratch.gif',
    speedDialPrimary: '{{configs.publicUrl}}/assets/images/speed-dial-primary.svg',
    newAutomation:
      '{{configs.publicUrl}}/merchants/{{configs.merchantName}}/images/new-automation.svg',
    giftWrapper: '{{configs.publicUrl}}/merchants/{{configs.merchantName}}/images/gift-wrapper.png',
    iphoneImage: '{{configs.publicUrl}}/assets/images/experience-iPhone-X.svg',
    experienceGiftBoxTitleImage:
      '{{configs.publicUrl}}/assets/images/experience-preview-gift-box-title.svg',
    experienceCollectionImage:
      '{{configs.publicUrl}}/assets/images/experience-preview-collection.svg',
    experienceEmailImage: '{{configs.publicUrl}}/assets/images/experience-email-content.svg',
    experienceBow: '{{configs.publicUrl}}/assets/images/experience-bow.svg',
    experienceCard: '{{configs.publicUrl}}/assets/images/experience-card.svg',
    experienceCarouselDot:
      '{{configs.publicUrl}}/assets/images/experience-preview-carousel-dot.svg',
    noPaymentMethod:
      '{{configs.publicUrl}}/merchants/{{configs.merchantName}}/images/no-payment-method.svg',
    rocketOnboarding:
      '{{configs.publicUrl}}/merchants/{{configs.merchantName}}/images/rocket-onboarding.svg',
    shareOptions: '{{configs.publicUrl}}/assets/images/share-options.svg',
    underMaintenance:
      '{{configs.publicUrl}}/merchants/{{configs.merchantName}}/images/under-maintenance.svg',
    logoFull:
      '{{configs.publicUrl}}/merchants/{{configs.merchantName}}/images/merchant-logo-web.svg',
    smartgiftFav:
      '{{configs.publicUrl}}/merchants/{{configs.merchantName}}/images/smartgift-fav.svg',
    smartGiftRibbon:
      '{{configs.publicUrl}}/merchants/{{configs.merchantName}}/images/sg-logo-ribbon-dark@2x.png',
    logoSmall: '{{configs.publicUrl}}/merchants/{{configs.merchantName}}/images/logo-small.svg',
    logoText: '{{configs.publicUrl}}/merchants/{{configs.merchantName}}/images/logo-text.svg',
    orderConfirmed:
      '{{configs.publicUrl}}/merchants/{{configs.merchantName}}/images/share-confirmed-order.svg',
    deviceCheck: '{{configs.publicUrl}}/merchants/{{configs.merchantName}}/images/device-check.svg',
    lineCutTextEditor: '{{configs.publicUrl}}/assets/images/line-cut.svg',
    charityModalIllustration:
      '{{configs.publicUrl}}/assets/illustrations/charity-modal-illustration.svg',
    viaReplyTable:
      '{{configs.publicUrl}}/merchants/{{configs.merchantName}}/images/via-reply-table.svg',
    teamsApp: '{{configs.publicUrl}}/assets/images/teams_dashboard.svg',
    teamsShareIcon: '{{configs.publicUrl}}/assets/images/teams-share-icon.svg',
    merchantLogoWeb:
      '{{configs.publicUrl}}/merchants/{{configs.merchantName}}/images/merchant-logo-web.svg',
    logo: '{{configs.publicUrl}}/merchants/{{configs.merchantName}}/images/logo.svg',
    giftPreviewBoxBow: '{{configs.publicUrl}}/assets/images/bow.svg',
    favicon: '{{configs.publicUrl}}/merchants/{{configs.merchantName}}/images/favicon.ico',
    favicon16: '{{configs.publicUrl}}/merchants/{{configs.merchantName}}/images/favicon-16x16.png',
    favicon32: '{{configs.publicUrl}}/merchants/{{configs.merchantName}}/images/favicon-32x32.png',
    welcome: '{{configs.publicUrl}}/merchants/{{configs.merchantName}}/images/send-gift.svg',
    viaReplyPreview: '{{configs.publicUrl}}/assets/images/via-reply-preview.svg',
    signUpVideoBackground:
      '{{configs.publicUrl}}/merchants/{{configs.merchantName}}/images/sign-up-video-background.png',
    greetingCardExperience:
      '{{configs.publicUrl}}/merchants/{{configs.merchantName}}/images/greeting-card.svg',
    confirmationWithContact:
      '{{configs.publicUrl}}/merchants/{{configs.merchantName}}/images/confirmation-with-contacts.svg',
    confirmationWithoutContact:
      '{{configs.publicUrl}}/merchants/{{configs.merchantName}}/images/confirmation-without-contacts.svg'
  }
};

export { theme };
